import { Button, ButtonProps } from "@chakra-ui/react";
import React, { FC, memo } from "react";

import colors from "app/colors";

const MessagePopoverQuickReplyButton: FC<ButtonProps> = ({
  children,
  onClick,
  ...props
}) => (
  <Button
    variant="custom"
    _hover={{ bg: colors.blueLight }}
    justifyContent="flex-start"
    fontWeight="normal"
    onClick={onClick}
    fontSize="sm"
    {...props}
  >
    {children}
  </Button>
);

export default memo(MessagePopoverQuickReplyButton);
